import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import GifPlayer from "react-gif-player";

import example1 from "../assets/images/carousel/carousel1.gif";
import example2 from "../assets/images/carousel/carousel2.gif";
import example3 from "../assets/images/carousel/carousel3.gif";
import example4 from "../assets/images/carousel/carousel4.gif";
import example5 from "../assets/images/carousel/carousel5.gif";
import "./HomeCarousel.css";

class HomeCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slides: [
        {
          figure: example1,
          alt:
            "The video shows a simulation outcome on a square lattice, initialized with a single stem cell. This cell divides asymmetrically and thereby generates progenitor cells which, after a few symmetric divisions, give rise to differentiated cells that cannot divide any further. Differentiated cells eventually encapsulate the stem and progenitor cells which terminates growth.",
        },
        {
          figure: example2,
          alt:
            "The video shows a simulation outcome on a hexagonal lattice, initialized with a single stem cell. This cell divides asymmetrically and thereby generates progenitor cells which, after a few symmetric divisions, give rise to differentiated cells that cannot divide any further. Differentiated cells eventually encapsulate the stem and progenitor cells which terminates growth.",
        },
        {
          figure: example3,
          alt:
            "The video shows a simulation outcome on a square lattice, initialized with a single stem cell. This cell divides and thereby generates progenitor cells, which after a few symmetric divisions, give rise to differentiated cells that cannot divide any further. At time step t=10, one randomly selected progenitor cell is transformed into a brain tumor stem cell (BTSC). Through rapid symmetric divisions, BSTCs escape the encapsulation by differentiated cells and form a growing tumorous tissue.",
        },
        {
          figure: example4,
          alt:
            "The video shows a simulation outcome on a hexagonal lattice, initialized with a single stem cell. This cell divides and thereby generates progenitor cells, which after a few symmetric divisions, give rise to differentiated cells that cannot divide any further. At time step t=10, one randomly selected progenitor cell is transformed into a brain tumor stem cell (BTSC). Through rapid symmetric divisions, BSTCs escape the encapsulation by differentiated cells and form a growing tumorous tissue.",
        },
        {
          figure: example5,
          alt:
            "The video shows a simulation outcome on a hexagonal lattice, initialized with a single brain tumor stem cell (BTSC). This cell, via rapid symmetric divisions, gives rise to other BTSCs which form an aggressively growing tumorous tissue.",
        },
      ],
      playing: true,
    };

    this.arrowStyles = {
      position: "absolute",
      zIndex: 2,
      top: "calc(50% - 15px)",
      width: 30,
      height: 30,
      cursor: "pointer",
    };

    this.indicatorStyles = {
      background: "#CCCCCC",
      width: 15,
      height: 15,
      display: "inline-block",
      margin: "-15px 20px",
    };
  }
  componentDidMount() {
    this.focusedItem.focus();
  }

  createCarouselItemImage = (figure, alt) => (
    <div key={alt}>
      <GifPlayer
        gif={figure}
        pauseRef={(pause) => (this.pauseGif = pause)}
        alt={alt}
        onTogglePlay={(playing) => this.setState({ playing })}
        autoplay
      />
    </div>
  );

  render() {
    return (
      <Carousel
        className="home-carousel"
        statusFormatter={(current, total) =>
          `Current slide: ${current} / Total: ${total}`
        }
        swipeable
        showStatus={false}
        autoPlay={false}
        stopOnHover
        infiniteLoop
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button
              className="ac-focus"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...this.arrowStyles, left: 15 }}
            >
              {"<"}
            </button>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button
              className="ac-focus"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...this.arrowStyles, right: 15 }}
              ref={(focus) => {
                this.focusedItem = focus;
              }}
            >
              {">"}
            </button>
          )
        }
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return (
              <li
                className="ac-focus"
                style={{ ...this.indicatorStyles, background: "#000" }}
                title={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              className="ac-focus"
              style={this.indicatorStyles}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              title={`${label} ${index + 1}`}
              aria-label={`${label} ${index + 1}`}
            />
          );
        }}
      >
        {this.state.slides.map((slide) =>
          this.createCarouselItemImage(slide.figure, slide.alt)
        )}
      </Carousel>
    );
  }
}
export default HomeCarousel;
